
let scrollTop;
export default {
    open: () => {
        scrollTop = document.scrollingElement.scrollTop;
        document.body.classList.add('modal-open');
        document.body.style.top = -scrollTop + 'px';
    },
    close: () => {
        try {
            document.body.classList.remove('modal-open');
            document.scrollingElement.scrollTop = scrollTop;
        } catch(err) {}   
    }
};


// WEBPACK FOOTER //
// ./src/common/js/modal.js